import { useQuery, UseQueryResult } from '@tanstack/react-query'
import {
  TExpandedAvailabilityRecipe,
  TRecipeAvailability,
} from '@mindfulchefuk/types/recipeAvailabilities'
import { fetcherGetRecipeAvailabilityById } from './fetcherGetRecipeAvailabilityById'

export const useGetRecipeAvailabilityById = (
  id: string | null
): UseQueryResult<TRecipeAvailability<TExpandedAvailabilityRecipe>> =>
  useQuery({
    queryKey: ['single-recipe-availability', { id }],
    queryFn: fetcherGetRecipeAvailabilityById,
    enabled: !!id,
  })
